<template lang="pug">
  div
    v-card
      v-toolbar(:color="theme.colors.primary" dark)
        v-btn(
          :to="{ name: 'institutions.index' }"
          icon
          exact
          title="Inapoi"
        )
          v-icon arrow_back
        v-toolbar-title Editare institutie
        div(class="flex-grow-1")
        template
          v-btn(
            :to="{ name: 'institutions.create' }"
            icon
            title="Adauga institutie"
          )
            v-icon add_circle
      validation-observer(ref="observer" @submit.prevent="sendRequest")
        v-form
          v-card-text
            v-row
              v-col(cols="12")
                validation-provider(name="name" :rules="form.name.validation.rules" v-slot="{ errors }")
                  v-text-field(
                    v-model="form.name.value"
                    :label="form.name.label"
                    :error-messages="errors"
                    required
                  )
              v-col(cols="12")
                validation-provider(name="uic" :rules="form.uic.validation.rules" v-slot="{ errors }")
                  v-text-field(
                    v-model="form.uic.value"
                    :label="form.uic.label"
                    :error-messages="errors"
                    required
                  )
              v-col(cols="12")
                validation-provider(name="labelsType" :rules="form.labelsType.validation.rules" v-slot="{ errors }")
                  v-select(
                    v-model="form.labelsType.value"
                    :items="labelsTypes"
                    :label="form.labelsType.label"
                    :error-messages="errors"
                    item-text="name"
                    item-value="value"
                    required
                  )
              v-col(cols="12" md="6")
                v-menu(
                  v-model="validFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                )
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      v-model="form.validFrom.value"
                      :label="form.validFrom.label"
                      prepend-icon="event"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    )
                  v-date-picker(
                    v-model="form.validFrom.value"
                    @input="validFromMenu = false"
                  )
              v-col(cols="12" md="6")
                v-menu(
                  v-model="validUntilMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                )
                  template(v-slot:activator="{ on, attrs }")
                    v-text-field(
                      v-model="form.validUntil.value"
                      :label="form.validUntil.label"
                      prepend-icon="event"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    )
                  v-date-picker(
                    v-model="form.validUntil.value"
                    @input="validUntilMenu = false"
                  )
          div(class="grey lighten-4 pa-3")
            v-card-actions
              v-spacer
              v-btn(color="success" type="submit") Actualizeaza
    template(v-if="user.role.name === 'developer' && institution")
      institution-export(:institution-id="id" class="mt-4")
      section-card(title="Status" class="mt-4")
        v-alert(
          v-if="institution.is_suspended"
          type="warning"
          dense
          text
          class="mb-0"
        ) Aceasta institutie este suspendata{{ institution.suspended_at ? ' din ' + institution.suspended_at.split(' ')[0] : '' }}. Site-ul public si accesul administratorilor sunt blocate.
        v-alert(
          v-else
          type="success"
          dense
          text
          class="mb-0"
        ) Institutia este activa. Prin suspendare se blocheaza site-ul public si accesul administratorilor, fara sa se stearga datele.
        template(#actions)
          v-btn(
            v-if="!institution.is_suspended"
            color="orange"
            dark
            @click="toggleSuspend(true)"
          ) Suspenda
          v-btn(
            v-else
            color="green"
            dark
            @click="toggleSuspend(false)"
          ) Reactiveaza
      section-card(title="Stergere institutie" class="mt-4")
        | Stergerea definitiva elimina institutia, utilizatorii, documentele si toate fisierele acesteia. Actiunea este ireversibila.
        template(#actions)
          institution-delete(
            :institution="institution"
            @deleted="$router.push({ name: 'institutions.index' })"
          )
            template(#activator="{ on, attrs }")
              v-btn(
                v-bind="attrs"
                v-on="on"
                color="red"
                class="white--text"
              ) Sterge definitiv
</template>
<script>
import { mapState } from 'vuex';
import InstitutionExport from '@/components/InstitutionExport';
import InstitutionDelete from '@/components/InstitutionDelete';
import SectionCard from '@/components/SectionCard';

export default {
  components: { InstitutionExport, InstitutionDelete, SectionCard },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    const labelsTypes = [
      {
        value: 0,
        name: 'De baza'
      },
      {
        value: 1,
        name: 'Extins'
      }
    ];

    return {
      labelsTypes,
      institution: null,
      validFromMenu: false,
      validUntilMenu: false,
      form: {
        name: {
          value: null,
          label: 'Nume',
          validation: {
            rules: {
              required: true
            }
          }
        },
        uic: {
          value: null,
          label: 'CUI',
          validation: {
            rules: {
              required: true
            }
          }
        },
        labelsType: {
          value: null,
          label: 'Tip etichete',
          validation: {
            rules: {
              required: true
            }
          }
        },
        validFrom: {
          value: null,
          label: 'Valabil de la'
        },
        validUntil: {
          value: null,
          label: 'Valabil pana la'
        }
      }
    };
  },
  computed: {
    ...mapState({
      user: s => s.auth.user,
      theme: s => s.config.theme
    })
  },
  mounted () {
    this.loadInstitutions();
  },
  methods: {
    parseDate (dateStr) {
      if (!dateStr) return null;
      // Handle d/m/Y format from API
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return dateStr;
    },
    loadInstitutions () {
      this.$store.commit('pageLoading', true);

      return this.axios.get(`/institutions/${this.id}`)
        .then(res => {
          this.institution = res.data.data;

          this.form.name.value = this.institution.name;
          this.form.uic.value = this.institution.uic;
          this.form.labelsType.value = this.institution.labels_type;
          this.form.validFrom.value = this.parseDate(this.institution.valid_from);
          this.form.validUntil.value = this.parseDate(this.institution.valid_until);
        })
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.$store.commit('pageLoading', false);
        });
    },
    getBody () {
      return {
        name: this.form.name.value,
        uic: this.form.uic.value,
        labels_type: this.form.labelsType.value,
        valid_from: this.form.validFrom.value,
        valid_until: this.form.validUntil.value
      };
    },
    sendRequest () {
      return this.$refs.observer.validate().then((valid) => {
        if (valid) {
          this.$store.commit('pageLoading', true);

          return this.axios.put(`/institutions/${this.id}`, this.getBody())
            .then(() => {
              this.$success('Institutia a fost actualizata.');
              this.loadInstitutions();
            })
            .catch(e => {
              if (e.response && e.response.data.status_code === 422 && e.response.data.hasOwnProperty('errors')) {
                this.$refs.observer.setErrors(e.response.data.errors);
              } else {
                this.$error(e);
              }
            }).finally(() => {
              this.$store.commit('pageLoading', false);
            });
        }
      });
    },
    toggleSuspend (suspend) {
      this.$store.commit('pageLoading', true);

      const action = suspend ? 'suspend' : 'reactivate';

      return this.axios.post(`/institutions/${this.id}/${action}`)
        .then(() => {
          this.$success(suspend ? 'Institutia a fost suspendata.' : 'Institutia a fost reactivata.');
          this.loadInstitutions();
        })
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.$store.commit('pageLoading', false);
        });
    }
  }
};
</script>
